import Vue from "vue";
import Vuetify from "vuetify/lib";
import fr from "vuetify/src/locale/fr.ts";
import pt from "vuetify/src/locale/pt.ts";
import colors from "vuetify/lib/util/colors";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

let config = {
  lang: {
    locales: { fr, pt },
    current: "fr",
  },
  icons: {
    iconfont: "mdi",
  },
  theme: {
    options: {
      customProperties: true,
    },
  },
};

if (process.env.VUE_APP_ENV !== "PROD") {
  const customColor = process.env.VUE_APP_ENV === "RECETTE" ? "green" : "teal";

  config.theme.themes = {
    light: {
      primary: colors[customColor].darken3,
      secondary: colors[customColor].lighten1,
      accent: colors.lime.base,
    },
  };
}

export default new Vuetify(config);
